import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Input, InputGroup, InputGroupAddon, FormGroup, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import api, { api2 } from '~/services/api';
import Loader from '~/components/Loader/Loader';
import { format } from 'date-fns';

export default function ModalCreateUserEvent({ showModal, toggle, loadUserEvents }) {
    const [loading, setLoading] = useState(false);

    const [users, setUsers] = useState([]);
    const [searchUserQuery, setSearchUserQuery] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [races, setRaces] = useState([]);
    const [searchRaceQuery, setSearchRaceQuery] = useState('');
    const [selectedRace, setSelectedRace] = useState(null);
    const [selectedDistance, setSelectedDistance] = useState('');

    const searchUsers = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.get(`users?searchQuery=${searchUserQuery}&page=1&limit=5`);
            setUsers(data.data || []);
        } catch (error) {
            toast.error('Erro ao pesquisar usuários');
        } finally {
            setLoading(false);
        }
    };

    const searchRaces = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        try {
            const startDate = format(new Date(), 'yyyy-MM-dd');
            const { data } = await api2.get(
                `race_calendar?name=${searchRaceQuery}&page=1&limit=50&start_date=${startDate}`
            );
            setRaces(data.data || []);
        } catch (error) {
            toast.error('Erro ao pesquisar provas');
        } finally {
            setLoading(false);
        }
    };

    const toggleUser = (userId) => {
        if (selectedUsers.includes(userId)) {
            setSelectedUsers(selectedUsers.filter(id => id !== userId));
        } else {
            setSelectedUsers([...selectedUsers, userId]);
        }
    };

    const handleSubmit = async () => {
        if (selectedUsers.length === 0) {
            toast.warn('Selecione pelo menos um usuário');
            return;
        }
        if (!selectedRace) {
            toast.warn('Selecione uma prova');
            return;
        }
        if (!selectedDistance) {
            toast.warn('Selecione uma distância');
            return;
        }

        setLoading(true);
        try {
            for (const userId of selectedUsers) {
                await api2.post('user-events', {
                    user_id: userId,
                    race_calendar_id: selectedRace._id,
                    distance: parseFloat(selectedDistance)
                });
            }
            toast.success('Inscrições realizadas com sucesso');
            loadUserEvents(1);
            toggle();
            // Reset state
            setSelectedUsers([]);
            setSelectedRace(null);
            setSelectedDistance('');
            setUsers([]);
            setRaces([]);
            setSearchUserQuery('');
            setSearchRaceQuery('');
        } catch (error) {
            toast.error('Erro ao realizar inscrições');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={showModal} toggle={toggle} style={{ maxWidth: '900px', width: '90%' }}>
            <ModalHeader toggle={toggle}>Nova Inscrição em Prova</ModalHeader>
            <ModalBody>
                {loading && <Loader />}
                <Row>
                    <Col md={6} style={{ borderRight: '1px solid #eee' }}>
                        <h5 className="mb-3">1. Selecionar Atletas</h5>
                        <form onSubmit={searchUsers}>
                            <InputGroup className="mb-2">
                                <Input
                                    placeholder="Pesquisar por email"
                                    value={searchUserQuery}
                                    onChange={(e) => setSearchUserQuery(e.target.value)}
                                />
                                <InputGroupAddon addonType="append">
                                    <Button color="info" size="sm">Pesquisar</Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </form>

                        <div className='mb-3'>
                            <div style={{ height: '250px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '4px', padding: '10px' }}>
                                {users.length > 0 ? (
                                    <table className="table table-sm mb-0">
                                        <tbody>
                                            {users.map((usr) => (
                                                <tr key={usr.id}>
                                                    <td style={{ borderTop: 'none' }}>
                                                        <FormGroup check>
                                                            <Label check style={{ cursor: 'pointer', fontSize: '13px' }}>
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={selectedUsers.includes(usr.id)}
                                                                    onChange={() => toggleUser(usr.id)}
                                                                />{' '}
                                                                {usr.name} <br />
                                                                <small className="text-muted">{usr.email}</small>
                                                            </Label>
                                                        </FormGroup>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="text-center py-4 text-muted"> Pesquise atletas para listar </div>
                                )}
                            </div>
                            <div className="mt-2">
                                <small className="text-primary">{selectedUsers.length} atleta(s) selecionado(s)</small>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <h5 className="mb-3">2. Selecionar Prova</h5>
                        <form onSubmit={searchRaces}>
                            <InputGroup className="mb-2">
                                <Input
                                    placeholder="Nome da prova"
                                    value={searchRaceQuery}
                                    onChange={(e) => setSearchRaceQuery(e.target.value)}
                                />
                                <InputGroupAddon addonType="append">
                                    <Button color="info" size="sm">Pesquisar</Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </form>

                        <div className="mb-3">
                            <div style={{ height: '250px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '4px', padding: '10px' }}>
                                {races.length > 0 ? (
                                    <ul className="list-group list-group-flush">
                                        {races.map((race) => (
                                            <button
                                                key={race._id}
                                                className={`list-group-item list-group-item-action py-2 ${selectedRace?._id === race._id ? 'active' : ''}`}
                                                onClick={() => {
                                                    setSelectedRace(race);
                                                    setSelectedDistance('');
                                                }}
                                                style={{ fontSize: '13px', textAlign: 'left', border: 'none' }}
                                            >
                                                <strong>{race.name}</strong> <br />
                                                <small>{race.city} - {race.state} - {format(new Date(race.date), 'dd/MM/yyyy')}</small>
                                            </button>
                                        ))}
                                    </ul>
                                ) : (
                                    <div className="text-center py-4 text-muted"> Pesquise provas para listar </div>
                                )}
                            </div>
                        </div>

                        {selectedRace && (
                            <div className="p-2 border rounded bg-light">
                                <h6 className="mb-2">Distância da Prova:</h6>
                                <FormGroup>
                                    {selectedRace.distance && selectedRace.distance.length > 0 ? (
                                        selectedRace.distance.map((dist) => (
                                            <FormGroup check inline key={dist} className="mr-3">
                                                <Label check style={{ cursor: 'pointer' }}>
                                                    <Input
                                                        type="radio"
                                                        name="distance"
                                                        value={dist}
                                                        checked={selectedDistance === dist.toString()}
                                                        onChange={(e) => setSelectedDistance(e.target.value)}
                                                    />{' '}
                                                    {dist} km
                                                </Label>
                                            </FormGroup>
                                        ))
                                    ) : (
                                        <div className="text-danger small">Nenhuma distância cadastrada para esta prova.</div>
                                    )}
                                </FormGroup>
                            </div>
                        )}
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>{' '}
                <Button color="success" onClick={handleSubmit} disabled={loading}>
                    Cadastrar Inscrições
                </Button>
            </ModalFooter>
        </Modal>
    );
}
